import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';
import { Z_INDEX } from '@/components/shared/constants/zIndex';
import { FlexColumnDiv } from '../common.StyledComponents';

export const Container = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: ${Z_INDEX.LOADING_SCREEN};
    background-color: rgba(0, 0, 0, 0.25);
`;

export const Content = styled(FlexColumnDiv)`
    box-shadow: 0px ${rem(4)} ${rem(4)} 0px #00000040;
    border-radius: ${rem(6)};
    gap: ${rem(12)};
    width: fit-content;
    padding: ${rem(32)};
    background-color: white;
    z-index: ${Z_INDEX.LOADING_SCREEN};
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const BodyTextContainer = styled.div`
    align-self: center;
    color: ${({ theme }) => theme.colors.greyscale.gray50};
`;

export const LoadingTextContainer = styled.div`
    align-self: center;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.greyscale.gray50};
`;
